import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useThemeStore } from '@stores/themeStore';
import { usePermission } from '@/hooks/usePermission';

const { Content } = Layout;

export const MainLayout: React.FC = () => {
  const { sidebarCollapsed } = useThemeStore();
  const { initializePermissions } = usePermission();

  // 初始化权限数据
  useEffect(() => {
    initializePermissions();
  }, [initializePermissions]);

  return (
    <Layout className="min-h-screen">
      {/* 侧边栏 */}
      <Sidebar />
      
      {/* 主内容区 */}
      <Layout 
        className="transition-all duration-300"
        style={{ marginLeft: sidebarCollapsed ? 80 : 220 }}
      >
        {/* 顶部导航 */}
        <Header />
        
        {/* 内容区域 */}
        <Content className="m-6 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm min-h-[calc(100vh-112px)]">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
